import React from 'react'
import {Divider, Tooltip} from "antd";
import {getCompressionColor} from "./ColorUtil";
const Percentage =(value)=>( value?`${value}`:'')
export const RotatableCircle = (props, outlierLowerBound, allowedLowerBound) => {
    return (
        props && props.angle &&
        <div>
            <div style={{backgroundColor:getCompressionColor(props.compression, outlierLowerBound, allowedLowerBound)}}>
                <span>{Percentage(props.compression)}</span><span style={{color:"#808080", fontSize:"0.8em"}}>{props.compression ? ' bits' : ''}</span>
            </div>
            <Divider style={{padding:0, margin:5}}/>
            <Tooltip title={`${props.angle}º`} color={"blue"} placement="right">
                <svg
                    width="60"
                    height="60"
                >
                    <circle id="circle" cx="30" cy="30" r="20" stroke="black" strokeWidth="2" fill="none" />
                    <line id="radius" x1="30" y1="30" x2={30+ 20 * Math.cos(((props.angle-90)* Math.PI) / 180)} y2={30+ 20 * Math.sin(((props.angle-90)* Math.PI) / 180)} stroke="blue" strokeWidth="2" />
                </svg>
            </Tooltip>
        </div>
    );
};

export const AngleSvg = (props) => (
    <svg
        fill="#000000"
        height="18"
        width="18"
        viewBox="0 0 512 400"
        xmlSpace="preserve"
        {...props}
    >
        <g>
            <g>
                <path d="M495.304,425.738H255.417c-3.576-52.031-23.828-100.842-58.185-140.23L401.371,81.37c6.52-6.52,6.52-17.091,0-23.611 c-6.519-6.52-17.091-6.52-23.611,0L4.89,430.629c-3.282,3.282-4.984,7.702-4.886,12.172c0.018,0.813,0.095,1.627,0.233,2.436 c0.207,1.214,0.55,2.416,1.034,3.586c2.584,6.239,8.672,10.307,15.425,10.307h222.609h256c9.22,0,16.696-7.475,16.696-16.696 S504.525,425.738,495.304,425.738z M57.002,425.738l116.562-116.561c28.136,32.988,44.927,73.446,48.38,116.561H57.002z" />
            </g>
        </g>
    </svg>
);
